import { AnalyticsDashboard } from './analytics/AnalyticsDashboard';

export function AnalyticsTab() {
  return (
    <div data-testid="analytics-tab">
      <AnalyticsDashboard />
    </div>
  );
}
